export default __webpack_public_path__ + "static/media/Asus-ExpertBook-B950.1bd29faa.jpg";